import type { GlobalErrorState403 } from '@ds/swymkit/tools'
import { GLOBAL_ERROR_EVENT } from '@ds/swymkit/tools'

import { logger } from '~/features-shared/libs/utils/logger'

function handleGlobalError(messageEvent: MessageEvent<string>, callback: (payload: GlobalErrorState403) => void): void {
  if (!messageEvent.data) {
    return
  }
  const { data: dataOrString } = messageEvent

  try {
    const {
      event,
      payload,
    }: {
      event: string
      payload: GlobalErrorState403
    } = typeof dataOrString === 'string' ? JSON.parse(dataOrString) : dataOrString
    // Not a relevant message
    if (event !== GLOBAL_ERROR_EVENT || !payload)
      return

    callback(payload)
  }
  catch (err) {
    logger.error(err)
  }
}

/**
 * This function is used to start and stop the event listener for the global error event
 *
 * @param callback The callback to be called when the 403 message is received
 * @returns triggers to start and stop the event listener
 *
 * @example
 * const { start, stop } = handleErrorAppNavigation(callback)
 * start() // Start listening for messages
 * stop() // Stop listening for messages
 */
export function handleErrorAppNavigation(callback: (payload: GlobalErrorState403) => void): {
  start: () => void
  stop: () => void
} {
  // Wrapped function to handle the global error event
  function localErrorHandler(messageEvent: MessageEvent<string>) {
    return handleGlobalError(messageEvent, callback)
  }

  return {
    start: () => {
      window.addEventListener('message', localErrorHandler, false)
    },
    stop: () => {
      window.removeEventListener('message', localErrorHandler, false)
    },
  }
}
